import { PropTypes } from 'prop-types'
import React from 'react'
import { useSelector } from 'react-redux'

import useClassNotification from 'hooks/useClassNotification'
import { SECONDARY_DEVICE } from 'services/webSockets/roomState/constants'
import { _isTeacher } from 'store/selectors/User'
import { _roomStateMsgData } from 'store/selectors/WebSocket'

import RoomLayoutArtefactWeb from './RoomLayoutArtefactWeb'
import RoomLayoutWeb from './RoomLayoutWeb'

const Layout = props => {
    const isTeacher = useSelector(_isTeacher)
    const data = useSelector(_roomStateMsgData)

    const isSecondaryDevice = data === SECONDARY_DEVICE && isTeacher

    console.count('Layout Component')

    useClassNotification()

    return props?.artefact && !isSecondaryDevice ? (
        <RoomLayoutArtefactWeb {...props} />
    ) : (
        <RoomLayoutWeb {...props} />
    )
}

Layout.propTypes = {
    students: PropTypes.arrayOf(PropTypes.element).isRequired,
    teacher: PropTypes.element,
    artefact: PropTypes.element,
}

Layout.defaultProps = {
    students: [],
    teacher: null,
    artefact: null,
}

export default Layout
